import { ActionButton, ActionButtonType, Drawer } from "@octopusdeploy/design-system-components";
import { Permission, type ParentEnvironmentResource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { Form, useForm } from "~/components/form/Form/Form";
import { ParentEnvironmentForm } from "./ParentEnvironmentForm";
export interface ParentEnvironmentDrawerProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    parentEnvironment: ParentEnvironmentResource;
}
export function ParentEnvironmentDrawer({ isOpen, onClose, onSuccess, parentEnvironment }: ParentEnvironmentDrawerProps) {
    const { model, setModel, formProps, createSaveAction, getFieldError } = useForm({
        formName: "Parent Environment Drawer",
        initialModel: parentEnvironment,
        onSubmit: async (repository, model) => await repository.ParentEnvironments.modify(model),
        submitPermission: {
            permission: Permission.EnvironmentEdit,
            environment: parentEnvironment.Id,
        },
        afterSubmit: async () => {
            onSuccess();
        },
    });
    const saveAction = createSaveAction();
    const saveActionAccessibleName = "Confirm Edit Parent Environment";
    const saveButton = (<ActionButton key={saveActionAccessibleName} type={ActionButtonType.Primary} label={saveAction.label} accessibleName={saveActionAccessibleName} onClick={() => saveAction.onClick(undefined)} disabled={saveAction.disabled} busyLabel={saveAction.busyLabel}/>);
    return (<Drawer isOpen={isOpen} onClose={onClose} customPrimaryAction={saveButton} onPrimaryButtonClick={() => saveAction.onClick(undefined)} title={model.Name} variant="default">
            <Form {...formProps}>
                <ParentEnvironmentForm model={model} setModel={setModel} getFieldError={getFieldError}/>
            </Form>
        </Drawer>);
}
